var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPbfNotRegisteredButReceivesTreat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7,
    rx: 7.5,
    ry: 7,
    fill: "#FFA903"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.95 11V2.662H9.912v6.513l-4.8-6.513H4.05V11h1.037V4.35L9.95 11h1z",
    fill: "#fff"
  })));
}
export default SvgPbfNotRegisteredButReceivesTreat;